import axios from 'axios';
import { API_URL } from 'utils/http';

export type SearchFieldKind = 'text' | 'boolean' | 'enum' | 'date' | 'async' | 'json';

export interface SearchFieldDto {
  /** Wire key the client sends inside `'…'=`. */
  field: string;
  label: string;
  kind: SearchFieldKind;
  autocomplete?: boolean;
  multiple?: boolean;
  json?: boolean;
  /** Value that matches "nothing set" on this field. */
  emptyValue?: string;
  options?: { value: string; label: string }[];
}

export interface SearchSchemaResponse {
  model: string;
  fields: SearchFieldDto[];
}

export function getSearchSchema(model: string) {
  return axios.get<SearchSchemaResponse>(`${API_URL}/advanced-search/${model}/schema`);
}

export function searchAutocomplete(model: string, field: string, q: string) {
  return axios.get<{ values: string[] }>(`${API_URL}/advanced-search/${model}/autocomplete`, {
    params: { field, q },
  });
}
